import React, { useEffect } from 'react';
import { DragDropTarget } from './FileUpload.styles';
import { useFileUploadContext } from './FileUploadContext';

interface Props {
  children: React.ReactNode;
  openFileSelect: () => void;
  id: string;
}

export const FileUploadDropTarget = ({
  children,
  openFileSelect,
  id,
}: Props) => {
  const { initialiseDropArea, removeDropArea } = useFileUploadContext();

  const preventDefault = (e: DragEvent) => e.preventDefault();
  useEffect(() => {
    window.addEventListener('dragover', preventDefault, false);
    window.addEventListener('drop', preventDefault, false);

    return () => {
      window.removeEventListener('dragover', preventDefault, false);
      window.removeEventListener('drop', preventDefault, false);
    };
  }, []);

  useEffect(() => {
    initialiseDropArea(id);

    return () => {
      removeDropArea();
    };
  }, [initialiseDropArea, removeDropArea, id]);

  const handleEnter = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      openFileSelect();
    }
  };

  return (
    <DragDropTarget onKeyDown={handleEnter} tabIndex={0} id={id}>
      {children}
    </DragDropTarget>
  );
};
